// extracted by mini-css-extract-plugin
export default {"tooltip":"jQFG0QWTgMDBYmaBmVwF","tooltipArrow":"e8SXjlO5O0zV58pQUl44","arrow":"iOwpK7zQZpzobhKsEauj","text":"EqZ2hRfWL3U9my_pGfE0","wrapper":"eisFvLU5rhYOObBx4Nea"};